import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ settings: {}, refresh: () => {} });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});

  const refresh = async () => {
    try {
      const { data } = await api.get("/public/settings");
      setSettings(data || {});
    } catch { /* ignore */ }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
